import type {
  AuthVerifyTokenRequestType,
  AuthVerifyTokenResponseType,
  UserSignUpMetadataType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import {
  apiV2AssertResponse,
  generateSellarMetaData,
  apiV2Request,
  ApiV2RequestScope,
} from "../apiV2Request";

export const useAuthVerifyToken = () => {
  return useMutation({
    networkMode: "always",
    retry: false,
    mutationFn: (request: {
      data: AuthVerifyTokenRequestType;
      sellarMetadata?: UserSignUpMetadataType;
    }) =>
      apiV2Request({
        timeout: 15000,
        scope: ApiV2RequestScope.Public,
        method: "post",
        path: `auth/verify-token`,
        data: request.data,
        sellarMetadata: request.sellarMetadata
          ? generateSellarMetaData(request.sellarMetadata)
          : undefined,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as AuthVerifyTokenResponseType,
      ),
  });
};
